export const IN_APP_NOTIFICATION_ACTION = 'IN_APP_NOTIFICATION_ACTION'
export const NotificationEvent = {
  READ : 'read',
  UNREAD: 'unread',
  LINK: "link"
}